// Components==============
import indexReflection from 'actions/reflection/index';
import Layout from 'components/Layout/Layout';
import BigToggle from 'components/UI/BigToggle/BigToggle';
import Container from 'components/UI/Container/Container';
import Title from 'components/UI/Title/Title';
import { AnimatePresence } from 'framer-motion';
import { useMediaQ } from 'hooks/useMediaQ';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import React, { createContext, useEffect, useState } from 'react';
import Dreams from './components/Dreams';
import People from './components/People';
import Progress from './components/Progress';
import Skills from './components/Skills';
import './StudentOverview.module.scss';
// =========================

export type StudentOverviewContextType = {
  loading: boolean;
};

export const StudentOverviewContext = createContext(
  {} as StudentOverviewContextType
);

type SelectedTypes =
  | 'reflection.terms.progress'
  | 'dream.terms.dreams'
  | 'reflection.terms.inspiration'
  | 'general.terms.skills';

export default function StudentOverview() {
  const dispatch = useReduxAction();

  useEffect(() => {
    dispatch(indexReflection());
  }, []);

  const loading = !!useRedux((state) => state.reflection?.loading);
  const contextValues = {
    loading,
  };

  const translate = useTranslate();

  const [selected, setSelected] = useState<SelectedTypes>(
    'reflection.terms.progress'
  );

  const query = useMediaQ('min', 768);

  return (
    <Layout grey>
      <StudentOverviewContext.Provider value={{ ...contextValues }}>
        <Container>
          <Title
            text={selected}
            loading={loading}
            right={
              <BigToggle
                selected={selected}
                setSelected={setSelected}
                values={[
                  'reflection.terms.progress',
                  'dream.terms.dreams',
                  'reflection.terms.inspiration',
                  'general.terms.skills',
                ]}
                white
                query={query}
              />
            }
          />
          <AnimatePresence>
            {selected === 'reflection.terms.progress' ? (
              <>
                {query ? (
                  <Progress />
                ) : (
                  <div styleName="no-mobile">
                    <img
                      src="/images/error-illustrations/thinking-white.svg"
                      alt="query"
                    />
                    <h2>{translate('nocontent.errors.query')}</h2>
                  </div>
                )}
              </>
            ) : selected === 'dream.terms.dreams' ? (
              <Dreams />
            ) : selected === 'reflection.terms.inspiration' ? (
              <People />
            ) : (
              <Skills />
            )}
          </AnimatePresence>
        </Container>
      </StudentOverviewContext.Provider>
    </Layout>
  );
}
